<template>
  <div id="app">
    <div class="warnInfo">本平台为非涉密平台，严禁处理、传输国家秘密</div>
    <table-box/>
    <nav-title v-if="$route.meta.pageTitle" />
    <pop-box v-if="popShow"></pop-box>
    <transition :name="transitionName">
      <!-- <keep-alive> -->
        <router-view v-if="!popShow" />
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data(){
    return{
      timer: null,
      downFn: this.throttle(() => {
        console.log('下一页')
      }, 2000),
      upFn: this.throttle(() => {
        console.log('上一页')
      }, 2000),
      flag: false
    }
  },
  computed: {
    ...mapState(['includeArr', 'transitionName', 'popData']),
    popShow(){
      return this.popData.showPop
    }
  },
  methods: {
    throttle (fun, delay) {
      // 定义 最后执行事件时间  timer
      let last, deferTimer
      return function () {
          const that = this
          const _args = arguments
          const now = new Date().getTime()
          deferTimer && clearTimeout(deferTimer)
          if (last && now < last + delay) {
              deferTimer = setTimeout(function () {
                  last = now
                  fun.apply(that, _args)
              }, last + delay - now)
          } else {
              last = now
              fun.apply(that, _args)
          }
      }
    },
    wheelFn(e){
      let down = true;
      if(e.detail){
        down = e.detail > 0
      }else{
        down = e.wheelDelta < 0
      }
      if(!this.flag){
        this.flag = true;
        if(down){
          //向下滚动 --- 滚动到下一页
          // this.downFn();
          console.log('下一页')
        }else{
          //向上滚动 --- 滚动上一页
          // this.upFn();
          console.log('上一页')
        }
        setTimeout(() => {
          this.flag = false;
        }, 3000)
      }
    },
  }
}
</script>
<style lang="less">
  #app {
    box-sizing: border-box;
    padding: 0.11rem 0.23rem 0.15rem 0.24rem;
    .flexColumn();
    .warnInfo{
      position: absolute;
      font-size: 0.2rem;
      top: 0.46rem;
      left: 1.6rem;
      color: red;
      z-index: 999;
    }
  }
  // .slide-right,.slide-left{
  //   position: fixed;
  //   left:0;
  //   right: 0;
  //   width: 100%;
  // } 
  // 进入过渡开始状态----向右移动
  .slide-right-enter{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translateX(-1000px) scale(0.5);
  }
  // 进入过渡开始状态----向左移动
  .slide-left-enter{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translateX(1000px) scale(0.5);
  }
  // 进入过渡生效状态
  .slide-right-enter-active,.slide-left-enter-active{
    transition: all 2s ease;
  }
  // 进入过渡结束状态
  .slide-right-enter-to,.slide-left-enter-to{
    opacity: 1;
    width: 100%;
    transform: translateX(0) scale(1);
  }
  // 离开过渡开始状态
  .slide-right-leave,.slide-left-leave{
    opacity: 1;
    width: 100%;
    transform: translateX(0) scale(1);
  }
  // 离开过渡生效状态
  .slide-right-leave-active,.slide-left-leave-active{
    transition: all 2s ease;
  }
  // 离开过渡结束状态
  .slide-right-leave-to{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translate(1000px) scale(0.5);
  }
  .slide-left-leave-to{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translate(-1000px) scale(0.5);
  }
</style>
